import React from 'react';
import * as styles from './AWFooter.module.css';

export const AWFooter: React.FC = () => {
    return (
        <footer className={styles.footer}>
            {/* Logo Section - White Background with Black Logo */}
            <div className={styles.logoSection}>
                <a href="https://www.nikoven.org" target="_blank" rel="noopener noreferrer">
                    <img
                        src="/assets/logo/11white_theme_logo.png"
                        alt="NikoVen Corporation"
                        className={styles.mainLogo}
                    />
                </a>
            </div>

            {/* Gradient Transition: Transparent to Black */}
            <div className={styles.gradientTransition}></div>

            {/* Footer Content - Black Background */}
            <div className={styles.footerContent}>
                <div className={styles.container}>
                    <div className={styles.brandSection}>
                        <img
                            src="/assets/logo/Icon_logo_White.png"
                            alt="NikoVen Logo"
                            className={styles.brandLogo}
                        />
                        <p className={styles.tagline}>
                            Conectando mercados globales con precisión y compromiso.
                        </p>
                    </div>

                    <div className={styles.divider} />

                    <div className={styles.mainGrid}>
                        <div className={styles.linkGroup}>
                            <h4 className={styles.groupTitle}>Company</h4>
                            <a href="#" className={styles.link}>About Us</a>
                            <a href="#" className={styles.link}>Our Story</a>
                            <a href="#" className={styles.link}>Careers</a>
                            <a href="#" className={styles.link}>Press</a>
                        </div>

                        <div className={styles.linkGroup}>
                            <h4 className={styles.groupTitle}>Services</h4>
                            <a href="#" className={styles.link}>Logistics</a>
                            <a href="#" className={styles.link}>Distribution</a>
                            <a href="#" className={styles.link}>Consulting</a>
                            <a href="#" className={styles.link}>Storage</a>
                        </div>

                        <div className={styles.linkGroup}>
                            <h4 className={styles.groupTitle}>Legal</h4>
                            <a href="#" className={styles.link}>Privacy Policy</a>
                            <a href="#" className={styles.link}>Terms of Service</a>
                            <a href="#" className={styles.link}>Cookie Policy</a>
                            <a href="#" className={styles.link}>Compliance</a>
                        </div>

                        <div className={styles.newsletterGroup}>
                            <h4 className={styles.groupTitle}>Stay Connected</h4>
                            <p className={styles.newsletterText}>Join our exclusive network for updates.</p>
                            <div className={styles.inputWrapper}>
                                <input type="email" placeholder="Email Address" className={styles.emailInput} />
                                <button className={styles.submitBtn}>→</button>
                            </div>
                            <div className={styles.socialRow}>
                                <a href="#" className={styles.socialLink}>INS</a>
                                <a href="#" className={styles.socialLink}>LKD</a>
                                <a href="#" className={styles.socialLink}>X</a>
                            </div>
                        </div>
                    </div>

                    <div className={styles.bottomSection}>
                        <p className={styles.copyright}>© 2025 NIKOVEN CORPORATION.</p>
                        <p className={styles.location}>ARUBA • WORLDWIDE</p>
                    </div>
                </div>
            </div>
        </footer>
    );
};
